import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-dynamic-confirmation',
  imports: [CommonModule],
  templateUrl: './dynamic-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dynamic-confirmation.component.scss',
})
export class DynamicConfirmationComponent implements AfterViewInit, OnDestroy {
  @Input() wrapperClass: string | string[] | Set<string> | { [key: string]: any } | null = null;
  @Input() wrapperStyle: { [key: string]: any } | null = null;

  showConfirmation: boolean = false;
  timeoutHandler: any | undefined;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.timeoutHandler = setTimeout(() => {
      this.showConfirmation = true;
      this.cdr.detectChanges();
    }, 100);
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutHandler);
  }
}
